import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BankListResponse, CityListResponse, DistrictListResponse, SearchCity, SearchDistrict, SearchWard, WardListResponse } from '../../modules/common/types/types';
import { ProductCategoryList, IntroduceInfoDetail, SpecsResponse, GetCategoryQuery, BannerResponseList, LinkResponse } from './apiTypes';
import { CommonListQuery } from './apiTypes';

export const systemApi = createApi({
    reducerPath: 'systemApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_API_URL + "/system-manager",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("accessToken");
            if (token) {
                headers.set('authorization', `Bearer ${token}`)
            }
            return headers;
        }
    }),
    endpoints: (builder) => ({
        getWardList: builder.query<WardListResponse, SearchWard>({
            query: (query) => `commune?keyword=${query.keyword || ""}&page=${query.page}&size=${query.size}&findByParentId=${query.districtId || ""}` +
                `&properties=modifiedDate&sortBy=DESC&status=${query.status === undefined ? "" : query.status}&findByParentId2=${query.provinceId || ""}`,
            transformResponse: (response: { body: WardListResponse }, meta, arg) => {
                return response.body;
            },
        }),
        getDistrictList: builder.query<DistrictListResponse, SearchDistrict>({
            query: (query) => `district?keyword=${query.keyword || ""}&page=${query.page}&size=${query.size}&findByParentId=${query.provinceId || ""}` +
                `&properties=modifiedDate&sortBy=DESC&status=${query.status === undefined ? "" : query.status}`,
            transformResponse: (response: { body: DistrictListResponse }, meta, arg) => {
                return response.body;
            },
        }),
        getProvinceList: builder.query<CityListResponse, SearchCity>({
            query: (query) => `province?keyword=${query.keyword || ""}&page=${query.page}&size=${query.size}` +
                `&properties=modifiedDate&sortBy=DESC&status=${query.status === undefined ? "" : query.status}`,
            transformResponse: (response: { body: CityListResponse }, meta, arg) => {
                return response.body;
            },
        }),
        getProductCategoryList: builder.query<ProductCategoryList, GetCategoryQuery>({
            query: (query) => `category?keyword=${query.keyword || ""}&page=${query.page}&size=${query.size}` +
                `&properties=modifiedDate&status=1&sortBy=DESC&isPublic=${query.isPublic || ""}`,
            transformResponse: (response: { body: ProductCategoryList }, meta, arg) => {
                return response.body;
            },
        }),
        getIntroduceDetail: builder.query<IntroduceInfoDetail, string>({
            query: (query) => `introduce?introduceCode=${query || ""}`,
            transformResponse: (response: { body: IntroduceInfoDetail }, meta, arg) => {
                return response.body;
            },
        }),
        getSpecsList: builder.query<SpecsResponse[], any>({
            query: (query) => `configSystem`,
            transformResponse: (response: { body: SpecsResponse[] }, meta, arg) => {
                return response.body;
            },
        }),
        getBannerList: builder.query<BannerResponseList, { status: number } & CommonListQuery>({
            query: (query) => ({
                url: `manager-banner/search?page=${query.page || 0}&size=${query.size || 10}&properties=modifiedDate&sortBy=DESC`,
                method: 'POST',
                body: {
                    status: query.status
                }
            }),
            transformResponse: (response: { body: BannerResponseList }, meta, arg) => {
                return response.body
            },
        }),
        getLinkList: builder.query<LinkResponse[], {}>({
            query: (query) => `manager-link/getall`,
            transformResponse: (response: { body: LinkResponse[] }, meta, arg) => {
                return response.body
            },
        }),
        getBankList: builder.query<BankListResponse, CommonListQuery>({
            query: (query) => `bank/getPage?keyword=${query.keyword || ""}&page=${query.page || 0}&size=${query.size || 10}` +
            `&properties=modifiedDate&sortBy=DESC&status=1`,
            transformResponse: (response: { body: BankListResponse }, meta, arg) => {
                return response.body
            },
        })
    })
})

export default systemApi;
export const {
    useLazyGetProvinceListQuery,
    useLazyGetDistrictListQuery,
    useLazyGetWardListQuery,
    useLazyGetProductCategoryListQuery,
    useLazyGetIntroduceDetailQuery,
    useLazyGetSpecsListQuery,
    useLazyGetBannerListQuery,
    useLazyGetLinkListQuery,
    useLazyGetBankListQuery
} = systemApi;